import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documentazione',
  templateUrl: './documentazione.component.html',
  styleUrls: ['./documentazione.component.css']
})
export class DocumentazioneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
